import React from 'react';
import { useNavigate } from 'react-router-dom';
import AdminNotificationBell from './AdminNotificationBell';

const AdminNavbar: React.FC = () => {
  const navigate = useNavigate();

  const handleLogout = () => {
    sessionStorage.removeItem('adminAuthenticated');
    navigate('/admin/login');
  };

  return (
    <nav className="header-bar-primary shadow-lg mt-4">
      <div className="container mx-auto px-4">
        <div className="flex justify-between items-center py-4">
          {/* Left side navigation buttons */}
          <div className="flex items-center gap-4">
            <button
              onClick={() => navigate('/admin/dashboard')}
              className="inline-flex items-center justify-center px-6 py-2 bg-transparent text-white border-2 border-white rounded-full font-semibold text-sm transition-all duration-300 ease-in-out hover:bg-white hover:text-[var(--primary-deep-blue)]"
            >
              Dashboard
            </button>
          </div>
          
          {/* Right side buttons */}
          <div className="flex items-center gap-4">
            <AdminNotificationBell variant="onPrimary" />
            <button
              onClick={() => navigate('/')}
              className="inline-flex items-center justify-center px-6 py-2 bg-white text-[var(--primary-deep-blue)] border-2 border-white rounded-full font-semibold text-sm transition-all duration-300 ease-in-out hover:bg-transparent hover:text-white hover:border-white"
            >
              View Website
            </button>
            
            <button
              onClick={handleLogout}
              className="inline-flex items-center justify-center px-6 py-2 bg-transparent text-white border-2 border-white rounded-full font-semibold text-sm transition-all duration-300 ease-in-out hover:bg-white hover:text-[var(--primary-deep-blue)]"
            >
              Logout
            </button>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default AdminNavbar;

